import {UI} from "../../../stem-core/src/ui/UIBase.js";

import {BasePanelPage} from "../PanelPage.jsx";
import {LoginWithEmailCode} from "../../common/auth/LoginWithEmailCodeForm.jsx";
import {Messages} from "../../Messages.js";
import {Router} from "../../../stem-core/src/ui/Router.jsx";


class EmailCodeConfirmationComponent extends LoginWithEmailCode {
    getBeforeInput() {
        return [
            <div className={this.styleSheet.title}>{Messages.authEmailConfirmationTitle}</div>,
            super.getBeforeInput(),
        ];
    }
}

export class EmailCodeConfirmationPanel extends BasePanelPage {
    render() {
        return <EmailCodeConfirmationComponent onWrongEmailButtonClick={() => Router.back()}/>;
    }
}
